import { Component } from 'js-component-framework';
import fastdom from 'fastdom';
import { keyCodes } from 'aria-components/utils';
import './heading-share.scss';

/**
 * Adds the ability to copy a link to a heading with an `id` attribute.
 */
class HeadingShare extends Component {
  /**
   * Create a new HeadingShare.
   *
   * @constructor
   */
  constructor(config) {
    super(config);

    this.setLink = this.setLink.bind(this);
    this.copyLink = this.copyLink.bind(this);

    /**
     * The link element.
     */
    const { link } = this.children;
    this.link = link;

    // The heading has an anchor and clipboard is available.
    if (
      null != link
      && navigator.clipboard
      && window.isSecureContext
    ) {
      this.setLink();
    }
  }

  /**
   * Set the link markup and attributes.
   */
  setLink() {
    // Add button role.
    this.link.setAttribute('role', 'button');

    // Set up spacebar support for button role.
    this.link.addEventListener('keydown', (event) => {
      const { SPACE } = keyCodes;

      if (SPACE === event.keyCode) {
        this.copyLink(event);
      }
    });

    this.link.addEventListener('click', this.copyLink);
  }

  /**
   * Copy the link to the users clipboard.
   *
   * @param {Event} event The event object.
   */
  copyLink(event) {
    event.preventDefault();

    navigator.clipboard.writeText(this.link.href)
      .then(() => {
        fastdom.mutate(() => {
          this.element.classList.add('heading-share--copied');

          // Clear the classname.
          setTimeout(() => {
            this.element.classList.remove('heading-share--copied');
          }, 500);
        });
      })
      .catch((err) => {
        console.error('Could not copy text: ', err); // eslint-disable-line no-console
      });
  }
}

/**
 * The HeadingShare cofiguration.
 *
 * @type {Object}
 */
const headingShareConfig = {
  name: 'heading-share',
  class: HeadingShare,
  querySelector: {
    link: '.heading-share__link',
  },
};

export default headingShareConfig;
